<template>
  <div class="progress" :style="`width: ${width}rem;`">
    <div class="bar" :style="`width: ${progress}%;`">
      <div class="desc">
        {{
          $t('envelope.stillShort', {
            value: reward
              ? Math.round((reward.totalReward - reward.currentReward) * 100) / 100
              : '--'
          })
        }}
      </div>
    </div>
    <div class="animation" v-if="showAnimation">+{{ addNum }}</div>
  </div>
</template>

<script>
import { getLocalStorage, Key, setLocalStorage } from '@/common/localStorage'
import { useEnvelopeStore } from '@/stores/envelope'
import { mapState } from 'pinia'

export default {
  props: {
    width: {
      type: Number,
      default: 4.8
    }
  },
  data() {
    return {
      addNum: 0,
      showAnimation: false,
      progress: 0
    }
  },
  computed: {
    ...mapState(useEnvelopeStore, ['reward'])
  },
  watch: {
    reward(newValue, oldValue) {
      const currentReward = getLocalStorage(Key.currentReward)
      if (!oldValue || (newValue && newValue.currentReward != oldValue.currentReward)) {
        this.progress = Math.min(
          Math.round((this.reward.currentReward / this.reward.totalReward) * 100),
          98
        )
        const newCurrentReward = newValue ? newValue.currentReward : 0
        const oldcurrentReward = currentReward != '' ? currentReward : 0
        this.addNum = Math.round((Number(newCurrentReward) - Number(oldcurrentReward)) * 100) / 100
        if (this.addNum > 0) {
          this.showAnimation = currentReward != ''
        }
        setLocalStorage(Key.currentReward, newCurrentReward)
      }
    }
  },
  mounted() {
    if (this.reward) {
      this.progress = Math.min(
        Math.round((this.reward.currentReward / this.reward.totalReward) * 100),
        98
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 0.48rem;
  background: #211d28;
  border-radius: 0.24rem 0.24rem 0.24rem 0.24rem;
  margin-top: 0.3rem;

  .bar {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    width: 0rem;
    height: 0.4rem;
    background: #009944;
    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
    margin-left: 0.04rem;

    .desc {
      min-width: 5rem;
      height: 0.4rem;
      font-size: 0.24rem;
      line-height: 0.4rem;
      color: #ffffff;
      border-radius: 0.16rem 0.16rem 0.16rem 0.16rem;
      margin-left: 0.2rem;
      text-align: left;
      // border: 0.02rem solid #ffffff;
    }
  }

  .animation {
    display: flex;
    width: auto;
    height: 0.22rem;
    font-family: DroidSans, DroidSans;
    font-weight: bold;
    font-size: 0.3rem;
    color: #e60012;
    line-height: 0.22rem;
    text-align: right;
    font-style: normal;
    text-transform: none;
    margin-top: 0rem;
    // background-color: aqua;
    animation: floatAndFade 2s ease-in-out forwards;
  }
}

@keyframes floatAndFade {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-50px) scale(2);
    /* 向上移动 */
    opacity: 0;
    /* 渐隐 */
  }
}
</style>
